
declare const customscripts: { nonce: string };

class PreHome {
  private body: HTMLElement = document.body;

  // Form
  private preHome: HTMLFormElement | null = null;
  private portRadios: NodeListOf<HTMLInputElement> | null = null;
  private readonly storageKey = 'selectedPort';

  // Popin
  private openPopinTriggers: NodeListOf<HTMLElement> | null = null;
  private popinContent: HTMLElement | null = null
  private closePopinTriggers: NodeListOf<HTMLElement> | null = null;

  constructor() {
    this.preHome = document.querySelector('[data-prehome]');
    this.init();
  }

  private async init(): Promise<void> {
    if (!this.preHome) {
      return;
    }
    // Port Sauvegardé > Redirection vers l'accueil du port
    const savedPort = localStorage.getItem(this.storageKey);
    if (savedPort) {
      // console.log(`Port sauvegardé trouvé: ${savedPort}. Redirection...`);
      const response = await fetch('/wp-json/haropa/v1/set-port-cookie', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-WP-Nonce': customscripts.nonce
        },
        body: JSON.stringify({ port_slug: savedPort })
      });

      if (!response.ok) {
        throw new Error('La réponse du serveur n\'est pas OK');
      }

      const redirectUrl = this.getRedirectUrl(savedPort);
      window.location.href = redirectUrl;
      return;
    }
 

    this.openPopinTriggers = document.querySelectorAll('[data-popin-guide-open]');
    this.popinContent = document.querySelector('[data-popin-guide-content]');
    this.closePopinTriggers = document.querySelectorAll('[data-popin-guide-close]');
    this.initPopinEvents();
  }

  private getRedirectUrl(savedPort : string): string {
    const currentLang = document.documentElement.lang;
    let redirectUrl = '';
    if (currentLang.startsWith('en')) {
      redirectUrl = `${window.location.origin}/en/${savedPort}/home`;
    } else {
      redirectUrl = `${window.location.origin}/${savedPort}/accueil`;
    }
    return redirectUrl;
  }

  // Popin
  private initPopinEvents(): void {
    this.openPopinTriggers?.forEach(trigger => {
      trigger.addEventListener('click', () => {
        this.openPopin();
      });
    });

    this.closePopinTriggers?.forEach(trigger => {
      trigger.addEventListener('click', () => {
        this.closePopin();
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.closePopin();
      }
    });
  }

  private openPopin(): void {
    this.popinContent!.classList.add('active');
    this.body.classList.add('unscrollable');
  }

  private closePopin(): void {
    this.popinContent!.classList.remove('active');
    this.body.classList.remove('unscrollable');
  }
}

export const preHome = new PreHome();
